import { gql } from '@apollo/client';
const GET_MODEL_SPECIFICATION_VARIANTS = gql `
  query GetModelSpecificationVariants($modelSpecificationId: ID!) {
    node(id: $modelSpecificationId) {
      ... on ModelSpecificationNode {
        id
        sizeStandard {
          id
          name
        }
        sizes {
          edges {
            node {
              id
              isActive
              sizeName {
                id
                name
              }
            }
          }
        }
        colors {
          edges {
            node {
              id
              name
              isActive
            }
          }
        }
        variants {
          edges {
            node {
              id
              isActive
              quantity
              color {
                id
                name
              }
              size {
                id
              }
            }
          }
        }
      }
    }
  }
`;
export default GET_MODEL_SPECIFICATION_VARIANTS;
